module.exports = __webpack_public_path__ + "a282e073dad281dff63a3ca6defa40a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/feedback-white.svg
// module id = 1319
// module chunks = 61